module.exports = __webpack_public_path__ + "static/media/game_cover_dicero.40da7ce9.png";